import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, ShieldAlert, Loader2 } from "lucide-react";
import { AuthShell } from "@/components/AuthShell";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/lso";

export default function LsoVerify() {
  const { certNum } = useParams();
  const [r, setR] = useState(null);

  useEffect(() => {
    const path = certNum.toUpperCase().startsWith("RNT-") ? "/lso-rental/verify/" : "/lso/verify/";
    api(`${path}${encodeURIComponent(certNum)}`, { auth: false })
      .then(setR)
      .catch(() => setR({ valid: false, reason: "Could not reach the ALR registry. Try again shortly." }));
  }, [certNum]);

  const name = r?.learner_name || r?.name;
  return (
    <AuthShell backLabel="ALR Portal">
      <p className="text-[11px] font-bold tracking-[0.3em] text-[#4CCC06]">LSO CERTIFICATE VERIFICATION</p>
      <p className="mt-2 font-mono text-xl font-bold" data-testid="verify-cert-number">{certNum}</p>
      {!r ? <Loader2 className="mt-6 animate-spin text-[#4CCC06]" /> : (
        <div className="mt-6" data-testid={r.valid ? "verify-valid" : "verify-invalid"}>
          {r.valid ? <BadgeCheck size={56} className="text-[#4CCC06]" /> : <ShieldAlert size={56} className="text-[#FF3333]" />}
          <h1 className="mt-3 font-display text-3xl font-extrabold uppercase">{r.valid ? "Valid certificate" : r.is_expired || r.reason === "Certificate expired" ? "Certificate expired" : "Not valid"}</h1>
          {!r.valid && r.reason && <p className="mt-1 text-sm text-neutral-400">{r.reason}</p>}
          <div className="mt-5 space-y-2 text-sm">
            {name && <p><span className="text-neutral-500">Holder:</span> <b>{name}</b></p>}
            {(r.franchise || r.location) && <p><span className="text-neutral-500">Location:</span> {r.franchise || r.location}</p>}
            {r.issued_at && <p><span className="text-neutral-500">Issued:</span> {fmtDate(r.issued_at)}</p>}
            {r.expires_at && <p><span className="text-neutral-500">Expires:</span> {fmtDate(r.expires_at)}</p>}
            {r.score_percent != null && <p><span className="text-neutral-500">Score:</span> {Math.round(r.score_percent)}%</p>}
          </div>
          <p className="mt-6 text-xs text-neutral-500">Issued by Advanced Laser Restoration. Aligned with ANSI Z136.1.</p>
        </div>
      )}
    </AuthShell>
  );
}
